import { Stack } from "@mui/material";
import { CircularLoading, NoDataWarning } from "../../../components/common";
import { HealthMedicineDetails } from "./HealthMedicineDetails";

interface IProps {
  data: any;
  loading?: boolean;
  setRefetch?: any;
  isRefetching?: boolean;
}

export function ControlPrescriptions({
  data,
  loading,
  setRefetch,
  isRefetching,
}: IProps) {
  return (
    <Stack>
      {data?.length ? (
        <Stack
          width="100%"
          spacing={2}
          sx={{ opacity: isRefetching ? 0.7 : 1, transition: "opacity 0.2s" }}
        >
          {data?.map((el: any) => (
            <HealthMedicineDetails
              key={el.date + el.name}
              fullData={el.fullResource}
              type={el.type}
              name={el.name}
              result={el.result}
              date={el.date}
              setRefetch={setRefetch}
            />
          ))}
        </Stack>
      ) : loading ? (
        <Stack
          height="100%"
          alignItems="center"
          justifyContent="center"
          spacing={2}
          p={3}
        >
          <CircularLoading />
        </Stack>
      ) : (
        <Stack width="100%" mt={2}>
          <NoDataWarning />
        </Stack>
      )}
    </Stack>
  );
}
